import axios from 'axios';

export const fetchPublicRegionOptions = (countryCode) => {
    return axios.get(`${window.__KEAP__.VUE_APP_CORE_PUBLIC_SPA_API_URL}/v1/countryAndProvince/${countryCode}`);
};

export const fetchPublicCountryOptions = () => {
    return axios.get(`${window.__KEAP__.VUE_APP_CORE_PUBLIC_SPA_API_URL}/v1/countryAndProvince`);
};
